import { render } from "./AddWice.vue?vue&type=template&id=6d1dd40f&scoped=true"
import script from "./AddWice.vue?vue&type=script&lang=js"
export * from "./AddWice.vue?vue&type=script&lang=js"

import "./AddWice.vue?vue&type=style&index=0&id=6d1dd40f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1dd40f"]])

export default __exports__